import React, { useEffect, useRef, useState } from 'react';
import styles from "./index.module.scss";
import { Balloon, Button, Input, Loading} from '@alifd/next';
import SmsTemplate from '@/components/CrowdSmsTemplate';
import LzDialog from '@/components/common/LzDialog';
import { Servlets } from '@/service';
import Text from './Text';
import LzMsg from '@/components/common/LzMsg';
import CONSTANTS from '@/utils/constant';
import UUID from '@/utils/UUID';
import SelectGoods from '@/components/SelectGoods';
import InsertCoupon from './InsertCoupon';
const ADDLENGTH = CONSTANTS.LZ_SMS_CANCEL_WORD.length + 3;
const CN_NTC_ADDLENGTH = 2; // 通知类短信没有拒收请回复R
const TYPE_LIST= {
  '会员中心页':1,
  '达人主页':2,
  '店铺首页':3,
  '商品详情页':4,
  '订单详情页':5,
  '优惠券链接':6,
  '店铺7分屏':7,
  '直播间':8,
}
function SmsPutSetting(props) {
  const { channelType, typeCode, smsParams, setSmsParams, pageDisable, pageType, refresh } = props;
  const childRef = useRef();
  const [clickTag, setClickTag] = useState({ key: '', value: '' });// 点击标签添加的链接
  const [sizeLength, setSizeLength] = useState(0);// 已输入字数
  const [everyMessageNum, setEveryMessageNum] = useState(1);// 每条短信算几条
  const [sign, setSign] = useState(''); // 短信签名
  const [currentSmsTypeData, setCurrentSmsTypeData] = useState();//当前短信类型数据
  const [currentParamsList, setCurrentParamsList] = useState();//当前的插入变量数据 
  const [phoneMessage,setPhoneMessage] = useState('');//右侧实时预览文案
  const [goodsVisible, setGoodsVisible] = useState(false); //选择商品组件
  const [couponVisible, setCouponVisible] = useState(false); //输入优惠券ID组件
  const [textLoading,setTextLoading] = useState(false);//短信输入框loading
  const [selectSmsTemplateDialog, setSelectSmsTemplateDialog] = useState(false);// 短信模板弹窗
  const [smsTemplateCount, setSmsTemplateCount] = useState(0);// 选择短信模板的时候，计数
  // 点击标签添加变量
  const handleClickParams = (v) => {
    setClickTag({ key: UUID.getUUID32(), value: v.name });
  };
  // 点击标签添加链接
  const handleClickLink = (v) => {
    setTextLoading(true);
    Servlets('getSmsShortLink',{type:TYPE_LIST[v.name],productId:v.productId || '',couponId:v.couponId || ''}).then((res) => {
      if(res.data){
        setClickTag({ key: UUID.getUUID32(), value: res.data.linkUrl });
        setTextLoading(false);
      }
    }).catch((e) => {
      console.log(e);
      setTextLoading(false);
    }) 
  };
  // 自定义的文本域
  const tagTextAreaChange = (value,templateId) => {
    // 用占位符替换算字数，第一次敲回车键会加两次字数，清掉一次回车键
    let str = value;
    const lastCharacter = str?.substr(str.length - 1, 1); // 最后1个字符,
    if ('\n'.includes(lastCharacter)) {
      // 如果是回车
      str = str.replace(/\n$/, ''); // 会多一个\n，需要清掉最后一个\n
    }
    // 要把链接tag换成对应个数的@
    str = str
      ?.replace(/\n/, '@')
      .replace(/#[^#]+#/g, (word) => {
        const obj = currentParamsList.find((item) => `#${item.name}#` === word);
        return new Array(obj?.wordNum).fill('@').join('');
      });
    // 内容长度
    const len = str?.length + sign.length + (channelType === 'CN_NTC' ? CN_NTC_ADDLENGTH : ADDLENGTH);
    setSizeLength(len);
    let newValue = value; //短信内容把变量替换成${变量}
    const obj = {};
    currentParamsList.forEach((item) => {
      obj[item.code] = `#${item.name}#`;
    });
    for (const key in obj) {
      const v = obj[key];
      newValue = newValue.replace(new RegExp(v, 'g'), key);
    }
    // 计算短信条数
    let tempCount = 1;
    if (+len <= 70 && len !== 0) {
      tempCount = Math.ceil(+len / 70);
    } else if (+len > 70) {
      tempCount = Math.ceil(+len / 67);
    }
    setEveryMessageNum(tempCount);
    console.log(newValue,value,templateId,'========================templateId')
    setSmsParams({
      ...smsParams,
      smsContent:newValue ? newValue :'', //发短信用的${变量}
      showContent:value ? value :'',//展示用的#变量#
      contentLength:len||0,
      smsSplitNum:tempCount,
      templateId:templateId
    });
  };
  const getSmsTypeInfo = () => {
    Servlets('smsModelType',{}).then((res) => {
      if(res.data){
        setCurrentSmsTypeData({...res.data.filter((item)=>{return item.channelType === channelType })[0]});
        setCurrentParamsList({...res.data.filter((item)=>{return item.channelType === channelType })[0]}.typeList.filter((item)=>{return item.typeCode === typeCode })[0].paramList);
      }
    }).catch((e) => {
      console.log(e);
    })
  }
  const getSign = () => {
    Servlets('getTitle', {}).then((res: { data: string }) => {
      const { shopName } = res.data;
      Servlets('getSmssign', { shopName }).then((res: { data: string }) => {
        setSign(res.data);
        setSmsParams({
          ...smsParams,
          sign:res.data,
          contentLength:res.data.length + (channelType === 'CN_NTC' ? CN_NTC_ADDLENGTH : ADDLENGTH),
        });
        setSizeLength(res.data.length + (channelType === 'CN_NTC' ? CN_NTC_ADDLENGTH : ADDLENGTH));
      }).catch((e) => {
        console.log(e);
      });
    });
  }
  const changeTypeDefault = ()=>{
    // setClickTag({ key: '', value: '' });
    // childRef.current.cleanText();
    // setEveryMessageNum(1);
    // setSizeLength(sign.length + ( channelType === 'CN_NTC' ? CN_NTC_ADDLENGTH : ADDLENGTH));
    // setPhoneMessage(`【${sign}】${ channelType === 'CN_NTC' ? '' :` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`}`);
  }
  /**
   * @description: 选择短信模板
   * @param {*} tmp 所选数据
   * @return {*}
   */
  const dealSmsContent = (tmp) => {
    tagTextAreaChange(tmp.templateShowContent.replace(` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`,''),tmp.templateId);
    setSmsTemplateCount((x) => x + 1);
    setSelectSmsTemplateDialog(false);  
  };

  useEffect(()=>{
    if(!sign){
      getSign();
    }
  },[sign])
  useEffect(()=>{
    //右侧手机展示内容
    const cancelWord = `${channelType === 'CN_NTC' ? '' :` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`}`
    let showMessage = smsParams.showContent ?`【${sign}】${smsParams.showContent}${cancelWord}` :`【${sign}】${cancelWord}`
    setPhoneMessage(showMessage);
  },[sign,smsParams.showContent]);
  useEffect(()=>{
    if (pageType===2) { 
      setSmsParams({
        ...smsParams,
        contentLength:smsParams.contentLength,
      });
      setSizeLength(smsParams.contentLength);
    }
  },[pageType,smsParams.contentLength])
  useEffect(()=>{
    getSmsTypeInfo();
  },[])
  useEffect(()=>{
    if (pageType===3) { 
      setSmsTemplateCount((x) => x + 1);
    }
  },[refresh])
    // useEffect(()=>{
  //   if(smsParams.templateId){
  //     setSmsTemplateCount((x) => x + 1);
  //   }
  // },[smsParams.templateId])
  return (
    <div>
      <div className={styles['big-box']}>
        <div className={styles['left-box']}>
          <div className={styles['params-box1']}>
            <div className={styles['title-box']}>
              插入变量：
            </div>
            <div className={styles['insert-params-box']}>
              {
                currentParamsList && currentParamsList.map((item)=>{
                  return (
                    // <Balloon.Tooltip
                    //   key={item.typeCode}
                    //   trigger={
                        <Button
                          size='small' 
                          type='secondary'
                          style={{borderRadius:'4px'}} 
                          disabled={pageDisable || Boolean(item.disable)}
                          onClick={() => handleClickParams(
                            {
                              ...item,
                              name:`#${item.name}#`
                            }
                          )}
                        >
                          {item.name}
                        </Button>
                  //     }
                  //   >
                  //   </Balloon.Tooltip>
                  )
                })
              }
            </div>
          </div>
          <div className={styles['params-box1']}>
            <div className={styles['title-box']}>插入链接：</div>
            <div className={styles['insert-params-box']}>
              {
                currentSmsTypeData && currentSmsTypeData.typeList.filter((item)=>{return item.typeCode === typeCode })[0].linkList.map((item)=>{
                  return (
                    // <Balloon.Tooltip
                    //   key={item.name}
                    //   trigger={
                        <Button
                          size='small'
                          type='secondary'
                          style={{borderRadius:'4px'}}
                          disabled={pageDisable || Boolean(item.disable)}
                          onClick={() =>  {
                            if(item.name==='商品详情页') {
                              setGoodsVisible(true);
                            }else if(item.name==='优惠券链接') {
                              setCouponVisible(true);
                            }else {
                              handleClickLink(item);
                            }
                          }}
                        >
                          {item.name}
                        </Button>
                    //   }
                    // >
                    // </Balloon.Tooltip>
                  )
                })
              }
            </div>
          </div>
          <div className={styles['params-box2']}>
            <div className={styles['title-box']}><span className={styles['red-text']}>*</span>短信内容：</div>
            <div>
              <Button
                size='small'
                type='secondary'
                disabled={pageDisable}
                style={{borderRadius:'4px',marginBottom:'8px'}}
                onClick={() =>  {
                  setSelectSmsTemplateDialog(true);
                }}
              >
                插入模板
              </Button>
              <Loading visible={textLoading}>
                <div style={{maxWidth:'600px'}}>
                  {
                    pageDisable ? 
                    <Input.TextArea
                      placeholder="请输入短信内容"
                      aria-label="TextArea"
                      style={{
                        width: '100%',
                        paddingTop: '5px',
                        marginRight: '10px',
                      }}
                      className={styles.messageContent}
                      value={smsParams.showContent}
                      rows={7}
                      disabled
                    />
                    :
                    <Text
                      cRef={childRef}
                      clickTag={clickTag}
                      defaultValue={(smsParams.templateId || pageType===3) ? smsParams.showContent : smsParams.smsContent}
                      smsTemplateCount={smsTemplateCount}
                      onChange={([smsContent,id])=>{tagTextAreaChange(smsContent, id)}}
                      templateId={smsParams.templateId}
                    />
                  }
                </div>
              </Loading>
              <div className={styles['gary-box']}>
                <div className={styles['left-box']}>
                  <div>
                    已输入：
                    <span className={styles['red-text']}>
                      {sizeLength}
                    </span>
                    /350字
                  </div>
                  {
                    channelType !== 'CN_NTC' && <div>（包含签名“{CONSTANTS.LZ_SMS_CANCEL_WORD}”）</div>
                  }
                  <div>
                    当前计费：
                    <span className={styles['red-text']}>
                      {everyMessageNum}
                    </span>
                    条
                  </div>
                </div>
                <div className={styles['gary-right-box']}>
                  <Balloon.Tooltip
                    trigger={<Button text type='primary' style={{marginRight:'5px'}}>内容规范</Button>}
                    align={"t"}
                  >
                    <div className={styles['tips-box']}>
                      <div>1、请您避免在短信正文中使用“￥、*、&、v、※、【】”等特殊字符，可能会导致短信出现乱码。</div>
                      <div>2、在短信签名和店铺名称中不得使用dy/抖音的字眼，且短信内容中不得有抖音字眼会误导公众任为是抖音发送的短信。</div>
                      <div>3、短信内容里不允许出现，POS机、代开发票、金融、毒品、赌博、众筹、慈善捐、股票、移民、面试招聘、彩票、返利、贷款、催款、投资理财、中奖、一元夺宝、一元秒杀、刷单、A货、医疗、整形、美容、会所、酒吧、足浴、暴力、恐吓、色情、内容不雅、皮草、助考、商标注册.加群、加QQ或者加微信、贩卖个人信息、APP下载链接、申请好评返现、宣传短信通道、用户拉新、用户召回、运营商相关(营业厅，移动,联通，电信等)、党政议论、上访维权、迷信、八卦风水、及其他违反法律法规的内容。</div>
                      <div>4、不允许向非企业会员用户发送短信，例如针对邀请注册、邀请加入会员等短信内容。</div>
                      <div>5、短信中只允许有1个链接不允许有多个，且必须为抖音域内的M页格式短链接。</div>
                      <div>6、插入变量后请不要修改变量内容，否则无法匹配到相应的内容!</div>
                    </div>
                  </Balloon.Tooltip>
                  <Balloon.Tooltip
                    trigger={<Button text type='primary'>计费规则</Button>}
                    align={"t"}
                  >
                    <div className={styles['tips-box']}>
                      <div>1.70个字计1条短信，超过70字按照67字每条计费。</div>
                      <div>2.一个汉字，字母或标点空格都算作一个字。</div>
                      <div>3.带标签短信以实际发送为准，由于变量值不同有可能超过默认字数。</div>
                      <div>4."签名"与营销短信类型时"{CONSTANTS.LZ_SMS_CANCEL_WORD}"包含在字数中。</div>
                    </div>
                  </Balloon.Tooltip>
                </div>
              </div>
              <div className={styles['tips-title']}>
                <div className={styles['red-text']}>
                  <span className={`iconfont icon-icon4-36`} style={{marginRight:'2px'}}/>
                  审核说明：短信模板由官方审核，审核时间: 4个小时内，工作时间：9:00~21:00（法定节假日延顺）
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles['right-box']}>
          <div className={styles.phoneBox}>
            <div className={styles.phoneImg}>
              <div
                className={styles.previewMessage}
                dangerouslySetInnerHTML={{ __html: `${phoneMessage}` }}
              />
            </div>
            <div className={styles['phone-tips-box']}>实时预览</div>
          </div>
        </div>
      </div>
      {
        goodsVisible && 
        <SelectGoods
          goodsDialog={goodsVisible}
          closeDialog={() => setGoodsVisible(false)}
          confirmSkuid={(v) =>{
            if(v.length>1) {
              LzMsg.error('一次只能选择一件商品!');
              return;
            } else if(v.length === 0) {
              LzMsg.error('请选择商品!');
              return;
            }else {
              setGoodsVisible(false);
              handleClickLink({name:'商品详情页',productId:v[0]});
            }
          }}
          skuIds={[]}
        />
      }
      {
        couponVisible && 
        <InsertCoupon
          couponVisible={couponVisible}
          setCouponVisible={()=>{
            setCouponVisible(false);
          }}
          couponConfirm={(v)=>{
            if(!v) {
              LzMsg.error('请输入优惠券ID!');
              return;
            }else {
              setCouponVisible(false);
              handleClickLink({name:'优惠券链接',couponId:v});
            }
          }}
        />
      }
      {
        //选择短信模板弹窗
        selectSmsTemplateDialog &&
        <LzDialog
          isFullScreen
          shouldUpdatePosition
          visible={selectSmsTemplateDialog}
          footer={false}
          title="选择短信模板"
          onCancel={() => setSelectSmsTemplateDialog(false)}
          onClose={() => setSelectSmsTemplateDialog(false)}
          style={{ width: 1060 }}
        >
          <SmsTemplate
            diySelect={(tem) => dealSmsContent(tem)}
            systemSelect={(tem) => dealSmsContent(tem)}
            historySelect={(tem) => dealSmsContent(tem)}
            modelTypeCode={typeCode}
          />
        </LzDialog>
      }
    </div>
  );
}

export default SmsPutSetting;
